<button type="button" class="hc-chip"
        [class.hc-chip--selected]="selected"
        [class.hc-chip--disabled]="disabled"
        [disabled]="disabled"
        (click)="toggle()"
        (keydown)="onKeydown($event)"
        [attr.aria-pressed]="selected">
  @if (leftIcon) {
    <lucide-icon [name]="leftIcon" [size]="20" class="hc-chip__icon" aria-hidden="true"></lucide-icon>
  }
  <span class="hc-chip__label"><ng-content></ng-content></span>
  @if (removable && !disabled) {
    <button type="button" class="hc-chip__remove" (click)="onRemove($event)" aria-label="Remove" tabindex="-1">
      <lucide-icon name="x" [size]="16" aria-hidden="true"></lucide-icon>
    </button>
  } @else if (rightIcon) {
    <lucide-icon [name]="rightIcon" [size]="20" class="hc-chip__icon" aria-hidden="true"></lucide-icon>
  }
</button>
